import { ITheme } from "../Theme.types.js";

export const mergeThemes = (base: ITheme, ...themes: Partial<ITheme>[]): ITheme =>
    themes.reduce<ITheme>((acc, theme) => ({ ...acc, ...theme }), base);
